'use client';

import { useEffect, useRef } from 'react';

import { CONTACT_COPY } from '@eliadmin/core/src/components/dlz/contact/contact-copy';
import { Icon } from '@eliadmin/core/src/components/dlz/ui/icon';
import { RichText } from '@eliadmin/core/src/components/dlz/ui/rich-text';
import Link from '@eliadmin/core/src/components/link';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { escapeHtml } from '@eliadmin/core/src/utils/dlz/text';

/**
 * Figma „Kontakt - odoslaný form“ 60333:28971 (phone 60438:81384): check, thank-you heading, the
 * administration text with the customer's e-mail, „Napísať ďalšiu správu“ and the way home. Takes
 * the focus when it replaces the form, so screen readers announce the result.
 */
export function ContactSent({
  email,
  text,
  onWriteAgain,
}: {
  email: string;
  /** HTML with `{email}`. */
  text: string;
  onWriteAgain: () => void;
}) {
  const headingRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    headingRef.current?.focus();
  }, []);

  return (
    <div className="flex flex-col items-center gap-4 text-center md:gap-6">
      <Icon name="check-circle" size={52} className="text-[#22A04B]" />
      <div className="flex max-w-[520px] flex-col gap-4">
        <h2
          ref={headingRef}
          tabIndex={-1}
          className="dlz-h2 scroll-mt-20 text-[#0F1012] outline-none lg:scroll-mt-28"
        >
          {CONTACT_COPY.sent.title}
        </h2>
        <RichText
          html={text.replaceAll('{email}', escapeHtml(email))}
          variant="dlz-body-m"
          className="text-[#4F545C]"
        />
      </div>
      <div className="flex w-full flex-col gap-3 @[32rem]:w-auto @[32rem]:flex-row">
        <Button
          type="button"
          variant="secondary"
          onClick={onWriteAgain}
          className="h-12 md:h-[52px]"
        >
          {CONTACT_COPY.sent.again}
        </Button>
        <Button asChild className="h-12 md:h-[52px]">
          <Link href={ROUTES.HOME() ?? '/'} prefetch={false}>
            {CONTACT_COPY.sent.home}
          </Link>
        </Button>
      </div>
    </div>
  );
}
